export default __webpack_public_path__ + "253abfb.png";